import { useMemo } from 'react';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import optimizeImage from '~/utilities/optimizeImage';

export enum ImageType {
  Cutout = 'cutout',
  JellyBean = 'jellybean'
}

export default function useGetImages() {
  const {
    stockImageData: { jellyBeanDesktopUrl = '' } = {},
    vexVdpImageData: { cutouts = [] } = {}
  } = useGetVehicleDetails();

  const targetCutout = cutouts.find(
    cutout => cutout.cameraHeight === 3 && cutout.angleDegrees === 219.375
  );

  const whyBuyImageMap = useMemo(() => {
    return {
      [ImageType.Cutout]: {
        url: targetCutout?.desktopURL
          ? optimizeImage(targetCutout.desktopURL, { width: 680 })
          : '',
        imageType: ImageType.Cutout,
        fallbackImageType: ImageType.JellyBean
      },
      [ImageType.JellyBean]: {
        url:
          jellyBeanDesktopUrl && !jellyBeanDesktopUrl.includes('generic')
            ? optimizeImage(jellyBeanDesktopUrl, { width: 680 })
            : '',
        imageType: ImageType.JellyBean
      }
    };
  }, [jellyBeanDesktopUrl, targetCutout?.desktopURL]);

  return {
    whyBuyImageMap,
    initialImageType: ImageType.Cutout
  };
}
